import React,{useState, useEffect} from "react";
// import Skin from '../images/Skin.svg';
// import SkinSecond from '../images/Skin-second.svg';
// import SkinThird from '../images/Skin-third.svg';
// import Background from '../images/Background.svg';
// import BackgroundBlue from '../images/Background-blue.svg';
import arrow from '../images/Right-arrow.svg';
// import BackgroundSecond from '../images/Background-second.svg';
// import BackgroundThird from '../images/Background-third.svg';
// import BackgroundSecondBlue from '../images/Background-second-blue.svg';
// import BackgroundThirdBlue from '../images/Background-third-blue.svg';
import ReactGA from "react-ga4";


export default function BackgroundBar(props){

    const [enabled, setEnabled] = useState(false);

    const [clickMode, setClickMode ] = useState(false)

    const [clickSecondMode, setClickSecondMode ] = useState(false)

    const [clickThirdMode, setClickThirdMode ] = useState(false)

    const [background, setBackground] = useState(true)

    // const [backgroundFirst, setBackgroundFirst] = useState(true)
    
    // const [backgroundSecond, setBackgroundSecond] = useState(true)

    function toggleBackground(){
        setBackground(false)
      
        setTimeout(() => {
            setBackground(true)
        }, 20000);
        
 
    }

    function toggleCloseBackground(){
        setBackground(true)
    }
   
    const onMouseDownHandler = () => {
        setClickMode(true);
        // console.log("onMouseDown Event!");
    };

    const onMouseDownSecondHandler = () => {
        setClickSecondMode(true);
        setBackground(false);
        // console.log("onMouseDown Event!");
    };

    const onMouseDownThirdHandler = () => {
        setClickThirdMode(true);
        // setBackground(false);
        // console.log("onMouseDown Event!");
    };

    const onMouseUpHandler = () => {
        setClickMode(false);
        setClickSecondMode(false);
        setClickThirdMode(false);
        // console.log("onMouseUp Event!");
    };

    const onMouseLeaveHandler = () => {
        setClickMode(false);
        setClickSecondMode(false);
        setClickThirdMode(false);
        // setBackground(true);
        // console.log("onMouseUp Event!");
    };

    useEffect(() => {
        setTimeout(() => {
            setEnabled(true)
          }, "200")
    }, [])
   

    const [className1, setclassName1] = useState("background--icon");

    const [className2, setclassName2] = useState("background--icon-2");

    const [className3, setclassName3] = useState("background--icon-3");


    return(

        (background)? 
            (  
                <div onClick={() => {
                        toggleBackground()
                        ReactGA.event({category: 'Engagement',action: "ui_env_menu",value: 1})
                    }}>
                    <div className="arrow-background-item">
                        <img src={arrow} alt="Logo" className="arrow--icon" />
                    </div>
                    <div className="background-item" >
                        <img src={(clickMode == true)? props.getBackgroundBlue(props.backgroundIds[0]) :props.getBackground(props.backgroundIds[0])}
                            onMouseDown={onMouseDownHandler}
                            onMouseUp={onMouseUpHandler}
                            onMouseLeave={onMouseLeaveHandler}
                            onTouchMove={onMouseLeaveHandler}
                            onTouchStart={onMouseDownHandler}
                            onTouchEnd={onMouseUpHandler}
                            onClick={() => {
                                props.onBackgroundClicked(props.backgroundIds[0])
                                ReactGA.event({category: 'Engagement',action: "ui_env_default",value: 1})
                            }}
                            alt="Logo" 
                            className={(clickMode == true)  ?  "background-close-icon"  : "background--icon" }
                        />                    
                    </div>
                </div>
            )
        :
        <div>
            <div className="background-item" onClick={() => {
                    toggleCloseBackground()
                    ReactGA.event({category: 'Engagement',action: "ui_env_menu",value: 1})
                }}>
                {/* <img src={Background} alt="Logo" className="background--icon" /> */}
                <img src={(clickMode == true)? props.getBackgroundBlue(props.backgroundIds[0]) :props.getBackground(props.backgroundIds[0])}
                        onMouseDown={onMouseDownHandler}
                        onMouseUp={onMouseUpHandler}
                        onMouseLeave={onMouseLeaveHandler}
                        onTouchMove={onMouseLeaveHandler}
                        onTouchStart={onMouseDownHandler}
                        onTouchEnd={onMouseUpHandler}
                        onClick={() => {
                            props.onBackgroundClicked(props.backgroundIds[0])
                            ReactGA.event({category: 'Engagement',action: "ui_env_default",value: 1})
                        }}
                        alt="Logo" 
                        className={(clickMode == true)  ?  "background-close-icon"  : "background--icon" }
                    />
            </div>
            <div className="background-item-1" >
              {/* <img src={BackgroundSecond} alt="Logo" className="background--icon-2" /> */}
              <img src={(clickSecondMode == true)? props.getBackgroundBlue(props.backgroundIds[1]) :props.getBackground(props.backgroundIds[1])}
                    onMouseDown={onMouseDownSecondHandler}
                    onMouseUp={onMouseUpHandler}
                    onMouseLeave={onMouseLeaveHandler}
                    onTouchMove={onMouseLeaveHandler}
                    onTouchStart={onMouseDownHandler}
                    onTouchEnd={onMouseUpHandler}
                    onClick={() => {
                        props.onBackgroundClicked(props.backgroundIds[1])
                        ReactGA.event({category: 'Engagement',action: "ui_env_gradient",value: 1})
                    }}
                alt="Logo"
               className={(clickSecondMode == true)? "background-close-icon" : className1}
                
               />

            </div>
            {enabled ? 
              <div className="background-item-2" >
              <img src={(clickThirdMode == true)? props.getBackgroundBlue(props.backgroundIds[2]) :props.getBackground(props.backgroundIds[2])}
                    onMouseDown={onMouseDownThirdHandler}
                    onMouseUp={onMouseUpHandler}
                    onMouseLeave={onMouseLeaveHandler}
                    onTouchMove={onMouseLeaveHandler}
                    onTouchCancel={onMouseLeaveHandler}
                    onTouchStart={onMouseDownHandler}
                    onTouchEnd={onMouseUpHandler}
                    onClick={() => {
                        props.onBackgroundClicked(props.backgroundIds[2])
                        ReactGA.event({category: 'Engagement',action: "ui_env_none",value: 1})
                    }}
                   alt="Logo" 
                   className={(clickThirdMode == true)? "background-close-icon" : className1}
                    
                   />
              </div>
              : null
            }
        </div>
    )         
}